module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-LightItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-LightItalic-webfont.woff
// module id = 350
// module chunks = 0